import { Expose } from 'class-transformer'
import { Home as HomeIcon } from '@material-ui/icons'

import { Base } from './Base'

export class Employee extends Base {
  static Icon = HomeIcon

  @Expose({ name: 'xid' })
  guid: string = ''

  email?: string

  @Expose({ name: 'first_name' })
  firstName?: string

  @Expose({ name: 'last_name' })
  lastName?: string

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }

  @Expose({ name: 'profile_image' })
  profileImage?: string
}
